/**
 * Utility to get the current authenticated user ID.
 *
 * Reads the Cognito access token managed by api-client.ts. This replaces
 * scattered db.auth.getUser() calls throughout the codebase.
 */

import { getAccessToken } from "./api-client";

/**
 * Get the current user ID (the Cognito `sub` claim).
 * Returns null if not authenticated.
 */
export async function getCurrentUserId(): Promise<string | null> {
  const token = getAccessToken();
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.sub || null;
  } catch {
    return null;
  }
}

/**
 * Get the current session token. Returns null if not authenticated.
 */
export async function getSessionToken(): Promise<string | null> {
  return getAccessToken();
}
